import React, { useEffect, useState } from 'react';
import { Input } from './ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';
import { PHONE_COUNTRIES } from '../constants/countries';
import { Flag } from './Flag';

/**
 * PhoneInput : selecteur pays (drapeau + indicatif) + numero.
 * Props : indicatif, number, onChange({indicatif, number}).
 */
export function PhoneInput({ indicatif, number, onChange, testIdPrefix = 'phone' }) {
  const [selectedCode, setSelectedCode] = useState(() => PHONE_COUNTRIES.find(c => c.dial === indicatif)?.code || '');
  useEffect(() => {
    setSelectedCode(current => PHONE_COUNTRIES.find(c => c.code === current)?.dial === indicatif
      ? current : PHONE_COUNTRIES.find(c => c.dial === indicatif)?.code || '');
  }, [indicatif]);
  const setInd = (code) => {
    const country = PHONE_COUNTRIES.find(c => c.code === code);
    if (!country) return;
    setSelectedCode(code);
    onChange({ indicatif: country.dial, number: number || '' });
  };
  const setNum = (v) => onChange({ indicatif: indicatif || '', number: v });
  const selected = PHONE_COUNTRIES.find(c => c.code === selectedCode && c.dial === indicatif)
    || PHONE_COUNTRIES.find(c => c.dial === indicatif);

  return (
    <div className="flex min-w-0 gap-2">
      <Select value={selected?.code || ''} onValueChange={setInd}>
        <SelectTrigger className="w-[140px]" data-testid={`${testIdPrefix}-indicatif`}>
          <SelectValue placeholder="Indicatif">
            {selected ? (
              <span className="flex items-center gap-1.5">
                <Flag iso={selected.iso} size={16} />
                <span>{selected.dial}</span>
              </span>
            ) : 'Indicatif'}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[260px]">
          {PHONE_COUNTRIES.map(c => (
            <SelectItem key={c.code} value={c.code} data-testid={`${testIdPrefix}-indicatif-opt-${c.code}`}>
              <span className="flex items-center gap-2">
                <Flag iso={c.iso} size={16} />
                <span className="text-xs text-[#5E6D66] w-14">{c.dial}</span>
                <span>{c.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        className="min-w-0"
        value={number || ''}
        onChange={(e) => setNum(e.target.value)}
        placeholder="6 12 34 56 78"
        data-testid={`${testIdPrefix}-number`}
      />
    </div>
  );
}

export default PhoneInput;
